// src/components/LoadingSequence.js
import React, { useEffect, useState } from 'react';
import { ReactComponent as LoadingGraphic } from '../css/loading.svg';
import './LoadingSequence.css';

const LoadingSequence = ({ message = 'Loading data...', size = 'large', fullPage = false }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : `${prev}.`));
    }, 400);

    return () => {
      clearInterval(dotsInterval);
    };
  }, []);

  return (
    <div className={`loading-sequence ${size} ${fullPage ? 'full-page' : ''}`.trim()}>
      <div className="loader-graphic-container">
        <LoadingGraphic className="loader-graphic" role="img" aria-label="PASS loading animation" />
        <div className="loading-message">
          {message}
          {dots}
        </div>
      </div>
    </div>
  );
};

export default LoadingSequence;
